import { render, staticRenderFns } from "./ContactInfoExtraFields.vue?vue&type=template&id=f09a65d2"
import script from "./ContactInfoExtraFields.vue?vue&type=script&lang=ts"
export * from "./ContactInfoExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f09a65d2')) {
      api.createRecord('f09a65d2', component.options)
    } else {
      api.reload('f09a65d2', component.options)
    }
    module.hot.accept("./ContactInfoExtraFields.vue?vue&type=template&id=f09a65d2", function () {
      api.rerender('f09a65d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoExtraFields.vue"
export default component.exports